import { defineDirective, isFunction, LayerBrowserContext, LmNode } from "../../omnia"

export class BrowserCtrl {

    static create() {
        return defineDirective(BrowserCtrl, "app/datalayers/menu/browser/browser.html", {
            context: "=",
            nodes: "=",
            level: "="
        })
    }

    context: LayerBrowserContext
    parent: LmNode
    nodes: LmNode[]
    level: number

    getCssClass(n: LmNode) {

        return (n.class || "")
            + (" l" + this.level)
            + (n.layer ? "" : " folder")
            + (n.layer && n.layer.visible ? " visible-layer" : "")
            + (this.isActiveLayer(n) ? " active-layer" : "")

    }

    isActiveLayer(n: LmNode) {
        return n.layer && (this.context.activeLayer == n.layer)
    }

    toggleNode(n: LmNode) {

        if (n.layer) {
            this.context.toggleLayer(n.layer)
        }
        else {
            n.expanded = !n.expanded
        }

    }

    canEditLayer(n: LmNode) {
        return (!!n.layer) && isFunction(this.context.editLayer)
    }

    editLayer(n: LmNode) {
        this.context.editLayer(n.layer)
    }

}
